import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { PathLocationStrategy } from '@angular/common';
import { APP_BASE_HREF } from '@angular/common';

import { HomeComponent } from './pages/home/home.component';
import { RegistrationComponent } from './pages/registration/registration.component';
import { RegistrationCompleteComponent } from './pages/registration-complete/registration-complete.component';
import { CheckUserComponent } from './pages/check-user/check-user.component';
import { VerifyTokenComponent } from './pages/verify-token/verify-token.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';

import { AccessabilityComponent } from './pages/about/accessability/accessability.component';
import { ArchiveComponent } from './pages/about/archive/archive.component';
import { CookiesComponent } from './pages/about/cookies/cookies.component';
import { CopyrightComponent } from './pages/about/copyright/copyright.component';
import { PrivacyComponent } from './pages/about/privacy/privacy.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: ':eventKey', component: CheckUserComponent },
  { path: ':eventKey/register', component: RegistrationComponent },
  { path: ':eventKey/thankyou', component: RegistrationCompleteComponent },
  { path: ':eventKey/verify/:token', component: VerifyTokenComponent },
  { path: 'error-page/:key', component: ErrorPageComponent },
  { path: 'about/copyright', component: CopyrightComponent},
  { path: 'about/privacy', component: PrivacyComponent},
  { path: 'about/cookies', component: CookiesComponent},
  { path: 'about/accessability', component: AccessabilityComponent},
  { path: 'about/archive', component: ArchiveComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
})
export class AppRoutingModule { }
